export default __webpack_public_path__ + "static/media/next.41534a03.svg";